// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ask Type+ — Quill surfaces inside chat bubbles and composer */

.chat-quill-readonly .ql-container.ql-snow,
.chat-quill-readonly .ql-container,
.chat-quill-readonly .ql-editor {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}

.chat-quill-readonly .ql-editor {
  padding: 0 !important;
  font-size: 14px;
  line-height: 1.5;
  color: inherit;
  cursor: default;
  overflow: visible;
  max-height: none;
}

.chat-quill-readonly .ql-editor p,
.chat-quill-readonly .ql-editor ul,
.chat-quill-readonly .ql-editor ol {
  margin: 0.35em 0;
}

.chat-quill-readonly .ql-editor pre {
  background: #111827;
  color: #f3f4f6;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  overflow-x: auto;
  font-size: 12px;
}

.chat-quill-readonly .ql-editor code {
  color: #db2777;
  font-size: 0.9em;
}

.chat-quill-readonly .ql-editor a {
  color: #2563eb;
  text-decoration: underline;
}

.chat-quill-composer .comment-input-editor .ql-editor {
  max-height: 200px;
  overflow-y: auto;
  min-height: 44px;
}

.chat-quill-composer .comment-input-container,
.chat-quill-composer .comment-input-editor {
  width: 100%;
}

/* Inline CRM action embeds from typecrm-ai contentDelta */
.chat-quill-readonly .chat-crm-action {
  display: inline-block;
  margin: 0.25rem 0.15rem 0.25rem 0;
  vertical-align: baseline;
}

.chat-quill-readonly .chat-crm-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  background: #fff;
  padding: 0.25rem 0.625rem;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  color: #374151;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background-color 0.15s,
    color 0.15s;
}

.chat-quill-readonly .chat-crm-action-btn:hover {
  border-color: #3b82f6;
  background: #eff6ff;
  color: #1d4ed8;
}

.chat-quill-readonly .chat-crm-action-btn:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/chat/components/chat-quill.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf;;;eAGa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Ask Type+ — Quill surfaces inside chat bubbles and composer */\n\n.chat-quill-readonly .ql-container.ql-snow,\n.chat-quill-readonly .ql-container,\n.chat-quill-readonly .ql-editor {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n  background: transparent !important;\n}\n\n.chat-quill-readonly .ql-editor {\n  padding: 0 !important;\n  font-size: 14px;\n  line-height: 1.5;\n  color: inherit;\n  cursor: default;\n  overflow: visible;\n  max-height: none;\n}\n\n.chat-quill-readonly .ql-editor p,\n.chat-quill-readonly .ql-editor ul,\n.chat-quill-readonly .ql-editor ol {\n  margin: 0.35em 0;\n}\n\n.chat-quill-readonly .ql-editor pre {\n  background: #111827;\n  color: #f3f4f6;\n  border-radius: 0.375rem;\n  padding: 0.5rem 0.75rem;\n  overflow-x: auto;\n  font-size: 12px;\n}\n\n.chat-quill-readonly .ql-editor code {\n  color: #db2777;\n  font-size: 0.9em;\n}\n\n.chat-quill-readonly .ql-editor a {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.chat-quill-composer .comment-input-editor .ql-editor {\n  max-height: 200px;\n  overflow-y: auto;\n  min-height: 44px;\n}\n\n.chat-quill-composer .comment-input-container,\n.chat-quill-composer .comment-input-editor {\n  width: 100%;\n}\n\n/* Inline CRM action embeds from typecrm-ai contentDelta */\n.chat-quill-readonly .chat-crm-action {\n  display: inline-block;\n  margin: 0.25rem 0.15rem 0.25rem 0;\n  vertical-align: baseline;\n}\n\n.chat-quill-readonly .chat-crm-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  background: #fff;\n  padding: 0.25rem 0.625rem;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #374151;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background-color 0.15s,\n    color 0.15s;\n}\n\n.chat-quill-readonly .chat-crm-action-btn:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.chat-quill-readonly .chat-crm-action-btn:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
